export { NameType } from './generated/NameType.js';